
export const ConstUserGroupEnum = {
    All: "00000000-0000-0000-0000-000000000000",
    Teacher:"00000000-0000-0000-0000-000000000001",
    Student:"00000000-0000-0000-0000-000000000002",
    Public: "ffffffff-ffff-ffff-ffff-ffffffffffff",
}